module.exports = __webpack_public_path__ + "img/logo-iib.010582bf.svg";